<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Información pruebas</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content align-items-center">
    <button class="btn btn-secondary" type="button" (click)="abrirAgregar(mdlAgregar)">Agregar Prueba</button>
  </div>
</div>

<div class="card">
  <div class="card-body">
    @if (cargando) { <p class="text-center mb-0">Cargando...</p> }

    @if (!cargando) {
      <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext">
          <thead>
            <tr>
              <th>#</th>
              <th>PRUEBA</th>
              <th>MUESTRA</th>
              <th>CONTENEDOR</th>
              <th>CONDICIÓN</th>
              <th>RESULTADOS</th>
              <th>TIPO DE RESULTADOS</th>
              <th>ESPECIFICACIONES</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pruebas; track item; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ item.NOMINF_LAB }}</td>
                <td>{{ item.MUEINF_LAB }}</td>
                <td>{{ item.CONINF_LAB }}</td>
                <td>{{ item.CONDINF_LAB }}</td>
                <td>{{ item.RESINF_LAB }}</td>
                <td>{{ item.TIPMUES_INF }}</td>
                <td>{{ item.ESPMUES_INF }}</td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-warning btn-sm" type="button" (click)="abrirEditar(mdlEditar, item)"><i class="zmdi zmdi-edit text-white"></i></button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="eliminarPrueba(item)"><i class="fa fa-times"></i></button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<ng-template #mdlAgregar let-modal>
  <div class="modal-header"><h6 class="modal-title">Agregar prueba</h6><button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button></div>
  <div class="modal-body">
    <div class="row g-2">
      <div class="col-md-6"><label>Prueba</label><input class="form-control" [(ngModel)]="formNueva.nombre"></div>
      <div class="col-md-6"><label>Muestra</label><input class="form-control" [(ngModel)]="formNueva.muestra"></div>
      <div class="col-md-6"><label>Contenedor</label><input class="form-control" [(ngModel)]="formNueva.contenedor"></div>
      <div class="col-md-6"><label>Condición</label><input class="form-control" [(ngModel)]="formNueva.condicion"></div>
      <div class="col-md-6"><label>Resultados</label><input type="number" min="1" class="form-control" [(ngModel)]="formNueva.resultadoNumero"></div>
      <div class="col-md-6"><label>Tiempo</label><select class="form-control" [(ngModel)]="formNueva.resultadoTiempo"><option value="DIAS">DIAS</option><option value="HORAS">HORAS</option><option value="MINUTOS">MINUTOS</option></select></div>
      <div class="col-md-6"><label>Tipo de resultados</label><input class="form-control" [(ngModel)]="formNueva.tipoResultado"></div>
      <div class="col-md-6"><label>Especificaciones</label><textarea class="form-control" [(ngModel)]="formNueva.especificaciones"></textarea></div>
    </div>
  </div>
  <div class="modal-footer"><button class="btn btn-light" (click)="modal.dismiss()">Salir</button><button class="btn btn-secondary" (click)="guardarPrueba()" [disabled]="guardando">Guardar</button></div>
</ng-template>

<ng-template #mdlEditar let-modal>
  <div class="modal-header"><h6 class="modal-title">Editar prueba</h6><button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button></div>
  <div class="modal-body">
    <div class="row g-2">
      <div class="col-md-6"><label>Prueba</label><input class="form-control" [(ngModel)]="formEditar.nombre"></div>
      <div class="col-md-6"><label>Muestra</label><input class="form-control" [(ngModel)]="formEditar.muestra"></div>
      <div class="col-md-6"><label>Contenedor</label><input class="form-control" [(ngModel)]="formEditar.contenedor"></div>
      <div class="col-md-6"><label>Condición</label><input class="form-control" [(ngModel)]="formEditar.condicion"></div>
      <div class="col-md-6"><label>Resultados</label><input type="number" min="1" class="form-control" [(ngModel)]="formEditar.resultadoNumero"></div>
      <div class="col-md-6"><label>Tiempo</label><select class="form-control" [(ngModel)]="formEditar.resultadoTiempo"><option value="DIAS">DIAS</option><option value="HORAS">HORAS</option><option value="MINUTOS">MINUTOS</option></select></div>
      <div class="col-md-6"><label>Tipo de resultados</label><input class="form-control" [(ngModel)]="formEditar.tipoResultado"></div>
      <div class="col-md-6"><label>Especificaciones</label><textarea class="form-control" [(ngModel)]="formEditar.especificaciones"></textarea></div>
    </div>
  </div>
  <div class="modal-footer"><button class="btn btn-light" (click)="modal.dismiss()">Salir</button><button class="btn btn-secondary" (click)="editarPrueba()" [disabled]="guardando">Guardar cambios</button></div>
</ng-template>
